<script setup lang="ts">
import { useRouterStore } from '@/stores/router'
import { pinia } from '@/stores'
import AppButton from '@/components/ui/AppButton.vue'
import { onBeforeMount, ref } from 'vue'
import { getItem } from '@/services/item'
import { useRemoteDiagnose } from '@/stores/remote-diagnose'
import { storeToRefs } from 'pinia'
import ProductCard from '../ui/ProductCard.vue'
import IntroductionContent from '@/lang/introduction.json'
import { useLang } from '@/composables/use-lang'

const props = defineProps({
  aws_url: { type: String, required: true },
  erpnext_url: { type: String, required: true }
})

const { push } = useRouterStore(pinia)
const remoteDiagnoseStore = useRemoteDiagnose(pinia)
const { state } = storeToRefs(remoteDiagnoseStore)

const item = ref<any>(null)
const error = ref<boolean>(false)
const langContent: any = useLang(IntroductionContent)

const next = () => push('whatsapp')

onBeforeMount(async () => {
  const result = await getItem(state.value.item, props.aws_url)
  if (!result) {
    error.value = true
    return
  }
  item.value = result
})
</script>

<template>
  <section v-if="langContent">
    <div class="flex flex-col-reverse lg:flex-row gap-4">
      <product-card v-if="item" :item="item" :erpnext_url="erpnext_url" :error="error" :texts="langContent" />

      <div class="lg:col-span-8">
        <h2 class="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
          {{ langContent.heading }}
        </h2>

        <p class="mt-3 max-w-2xl text-base leading-relaxed text-slate-600">
          {{ langContent.intro }}
        </p>

        <div class="mt-4 flex flex-wrap items-center gap-2">
          <span v-for="badge in langContent.badges" :key="badge"
            class="rounded-full border border-slate-200 bg-anti-flash-white px-3 py-1 text-xs font-semibold text-slate-700">
            {{ badge }}
          </span>
        </div>

        <div class="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
          <div v-for="(step, idx) in langContent.steps" :key="step"
            class="flex gap-3 items-center rounded-2xl border border-slate-200 bg-white p-4">
            <div
              class="flex h-9 w-9 flex-none items-center justify-center rounded-xl border border-red-200 bg-red-50 text-sm font-extrabold text-red-700">
              {{ Number(idx) + 1 }}
            </div>
            <p class="text-sm text-slate-700">{{ step }}</p>
          </div>
        </div>

        <div class="mt-5 rounded-2xl border border-slate-200 bg-white p-5">
          <p class="text-sm font-extrabold text-slate-900">{{ langContent.benefitsHeading }}</p>
          <p class="mt-2 text-sm text-slate-600">
            {{ langContent.pioneeringText }}
          </p>

          <ul class="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
            <li v-for="benefit in langContent.benefits" :key="benefit" class="flex items-start gap-2">
              <span class="mt-2 h-1.5 w-1.5 flex-none rounded-full bg-red-600"></span>
              <span class="text-sm leading-relaxed text-slate-600">{{ benefit }}</span>
            </li>
          </ul>
        </div>

        <app-button @click="next"
          class="mt-6 w-full rounded-xl px-6 py-3 text-base font-extrabold shadow-sm hover:shadow transition sm:w-auto">
          {{ langContent.button }}
        </app-button>
      </div>
    </div>
  </section>
</template>

<style scoped></style>
